// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1xH90","calendarButtons":"ClockData_calendarButtons__1CvgC"};